import { render } from "./DocTildaView.vue?vue&type=template&id=13cd3b03"
import script from "./DocTildaView.vue?vue&type=script&lang=js"
export * from "./DocTildaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__